import React, { useContext } from 'react';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';
import { GlobalContext } from '../../state/global/GlobalContextProvider';

export default function TrellisSnakBar() {
  const globalCtx = useContext(GlobalContext);
  const Alert = React.forwardRef(function Alert(prop, ref) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...prop} />;
  });
  return (
    <Snackbar open={globalCtx.globalState.alert.status} autoHideDuration={3000} anchorOrigin={{ vertical: "top", horizontal: "right" }}>
      <Alert severity={globalCtx.globalState.alert.severity} sx={{ width: '100%' }}>
        {globalCtx.globalState.alert.message}
      </Alert>
    </Snackbar>
  );
}